import 'normalize.css/normalize.css';
import 'tailwindcss/tailwind.css';
import './styles/global.css';
import './styles/icon/iconfont.css';
import 'animate.css';
import './styles/tooltip.css';
import '@/styles/sandbox/index.scss';

import Vue from 'vue';

import App from './app.vue';
import router from './router';
import store from './store';
import apis from './utils/apis';
import forchangeInfo from '@forchange/info';
import VTooltip from 'v-tooltip';
import Message from '@/components/message';
import { modalInstance } from '@/components/common/modal/index';

import SequenceStack from './utils/portal/SequenceStack';

import { ClemanClient, ApolloError } from '@forchange/cleman-client';

import '@panda/scroll';

// polyfill
import 'array-flat-polyfill';
import 'intersection-observer';

// katex
import VueKatex from 'vue-katex';
import 'katex/dist/katex.min.css';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

// code highlight
import Prism from 'prismjs';
import './styles/code/themes.css';

// code highlight
Prism.highlightAll();
Vue.directive('highlight', function(el) {
  const blocks = el.querySelectorAll('code');
  blocks.forEach((block) => {
    let language = '';
    for (const item of block.classList) {
      if (item.startsWith('language-')) {
        language = item.replace('language-', '');
        break;
      }
    }
    if (!language) return;
    try {
      block.innerHTML = Prism.highlight(block.innerText, Prism.languages[language], language);
    } catch (error) {
      console.log(`markdown代码块当前不支持的语言类型'${language}'`);
    }
  });
});

Vue.use(VTooltip);
Vue.use(Message);
Vue.use(VueKatex);

Vue.prototype.$Modal = modalInstance;

window.$getClemanClient = Vue.prototype.$getClemanClient = () => {
  const clemanClient = new ClemanClient();
  // const config = window.ENV === 'PROD' ? undefined : { baseURL: 'https://test.cleword.cn/api' };
  // const clemanClient = new ClemanClient(config);
  // clemanClient.token =
  //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cGRhdGVkX2F0IjoiMjAyMy0wMy0wM1QwMjozNjowNi40OTlaIiwiYWRkcmVzcyI6eyJjb3VudHJ5IjpudWxsLCJwb3N0YWxfY29kZSI6bnVsbCwicmVnaW9uIjpudWxsLCJmb3JtYXR0ZWQiOm51bGx9LCJwaG9uZV9udW1iZXJfdmVyaWZpZWQiOnRydWUsInBob25lX251bWJlciI6IjEzMjY2NzMyNTczIiwibG9jYWxlIjpudWxsLCJ6b25laW5mbyI6bnVsbCwiYmlydGhkYXRlIjpudWxsLCJnZW5kZXIiOiJVIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJlbWFpbCI6bnVsbCwid2Vic2l0ZSI6bnVsbCwicGljdHVyZSI6Imh0dHBzOi8vc2VjdXJlLmdyYXZhdGFyLmNvbS9hdmF0YXIvNzAwMzhhY2NiODIzZDAzNzRjMTBhYzdmMjJmZjBjYjg_cz04MCZkPWlkZW50aWNvbiIsInByb2ZpbGUiOm51bGwsInByZWZlcnJlZF91c2VybmFtZSI6bnVsbCwibmlja25hbWUiOiJsaSAgeGluIiwibWlkZGxlX25hbWUiOm51bGwsImZhbWlseV9uYW1lIjpudWxsLCJnaXZlbl9uYW1lIjpudWxsLCJuYW1lIjpudWxsLCJzdWIiOiI2MGMwNmJiZTc4N2Q3ZmM2M2Y4ZDIxMzQiLCJleHRlcm5hbF9pZCI6bnVsbCwidW5pb25pZCI6bnVsbCwidXNlcm5hbWUiOm51bGwsImRhdGEiOnsidHlwZSI6InVzZXIiLCJ1c2VyUG9vbElkIjoiNjBiOWRkZmViZGM3NzJmYWY2MDQxZGJiIiwiYXBwSWQiOiI2MGI5ZTk5YjExZjQ0YzU3Y2MzYjc2NzgiLCJpZCI6IjYwYzA2YmJlNzg3ZDdmYzYzZjhkMjEzNCIsInVzZXJJZCI6IjYwYzA2YmJlNzg3ZDdmYzYzZjhkMjEzNCIsIl9pZCI6IjYwYzA2YmJlNzg3ZDdmYzYzZjhkMjEzNCIsInBob25lIjoiMTMyNjY3MzI1NzMiLCJlbWFpbCI6bnVsbCwidXNlcm5hbWUiOm51bGwsInVuaW9uaWQiOm51bGwsIm9wZW5pZCI6bnVsbCwiY2xpZW50SWQiOiI2MGI5ZGRmZWJkYzc3MmZhZjYwNDFkYmIifSwidXNlcnBvb2xfaWQiOiI2MGI5ZGRmZWJkYzc3MmZhZjYwNDFkYmIiLCJhdWQiOiI2MGI5ZTk5YjExZjQ0YzU3Y2MzYjc2NzgiLCJleHAiOjE2NzkwMjQyMTEsImlhdCI6MTY3NzgxNDYxMSwiaXNzIjoiaHR0cHM6Ly90ZXN0LWNsZXdvcmQuYXV0aGluZy5jbi9vaWRjIn0.mi8O7OYxOgMe_fzpTVCkZ1VV7ZofnLjd9evuCiCkGpQ';
  return clemanClient;
};

Vue.prototype.$errorHandler = (err: any) => {
  console.error(err);
  if (err instanceof ApolloError) {
    // Apollo 错误信息
    err.graphQLErrors.forEach((item) => {
      if (item.extensions!.code === 'ENTITY_NOT_FOUND') {
        Message.Message.error({
          time: 5000,
          content: '404啦，请反馈给开发小伙伴'
        });
      } else if (item.extensions!.code === 'UNAUTHENTICATED') {
        // Apollo 端API授权失败 退出重新登陆
        Message.Message.error({
          time: 5000,
          content: '登录已失效，没办法保存您的学习情况啦'
        });
      } else {
        msg();
      }
    });
  } else {
    msg();
  }
};

const msg = () => {
  Message.Message.error({
    time: 5000,
    content: '哎呀，服务出问题啦，找找开发小伙伴'
  });
};

typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  forchangeInfo({ project: 'SURFER' });

window.apis = apis;

if (window.ENV === 'PROD') {
  Sentry.init({
    Vue,
    dsn: 'https://d862702e3ddb47a8805ccf634b24a046@sentry.forchange.cn/15',
    tracingOptions: {
      trackComponents: true
    },
    tracesSampleRate: 0,
    integrations: [new Integrations.BrowserTracing()],
    ignoreErrors: ['Non-Error promise rejection captured'],
    beforeSend(event, hint) {
      Sentry.setTag('url', window.location.href);
      Sentry.setTag('parentUrl', window.parent.location.href);
      Sentry.setTag('topUrl', window.top?.location.href);
      return event;
    },
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.message?.includes('extension')) {
        return null;
      }

      if (breadcrumb.message?.includes('Penpal')) {
        return null;
      }

      if (breadcrumb.message?.includes('padding')) {
        return null;
      }

      return breadcrumb;
    }
  });
}

window.sequenceStack = SequenceStack.init();
const vue = new Vue({
  el: '#surfer',
  router,
  store,
  components: { App },
  render: (h) => h(App)
});

export default vue;
